import {createGlobalStyle} from 'styled-components';
import {rootElement} from './config';

const Shadow = {
    BLOCK: 'var(--shadow-block)',
};

const GlobalShadows = createGlobalStyle`
    ${rootElement} {
        --shadow-block: 0px 2px 12px rgba(0, 0, 0, 0.12);
    }
`;

export {Shadow, GlobalShadows};
